import * as ppqActions from "../ppq/actionTypes";
import * as chooseAndBookActions from "../chooseAndBook/actionTypes";

import { PpqAction } from "../ppq/actions";
import { BookAppointmentSucessAction } from "../chooseAndBook/actions";

import { ActionableTask } from "./models";
import * as actions from "./actionTypes";
import { ActionableTaskAction } from "./actions";

export function actionableTasks(state: ActionableTask[] = [], action: ActionableTaskAction | PpqAction | BookAppointmentSucessAction): ActionableTask[] {
    switch (action.type) {
        case actions.LOAD_ACTIONABLE_TASKS_SUCCESS:
            return action.payload;
        case ppqActions.SUBMIT_EMPLOYEE_SECTION_QUESTIONNAIRE_SUCCESS:
        case chooseAndBookActions.BOOK_APPOINTMENT_SUCCESS:
            return state.filter(t => t.id !== action.payload.taskId);
        default:
            return state;
    }
}
